import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import CenterAddBankAccountWidget from '../../../widgets/contractCenterAddBankAccount/CenterAddBankAccountWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getBankAccount } from '../../../redux/actions/contract'
import BindRmsAccountWidget from '../../../widgets/contractCenterAddBankAccount/BindRmsAccountWidget'
import StampedDocumentWidget from '../../../widgets/contractCenterAddBankAccount/StampedDocumentWidget'
export default function CenterAddBankAccount() {
  //ขั้นที่ 3 บัญชีเงินฝากธนาคารสำหรับเบิกจ่าย
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [isSave, setIsSave] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let contractId = location.search.substring(1)
    // // let contractId = sessionStorage.getItem('param')?.substring(1)
    // console.log('load CenterAddBankAccount contract_id: ', projectId, 'contract_id: ', contractId)
    if (projectId) {
      //   projectId == 'mock-contract' ? setSchema(mockSchema) : handleGetSchema(projectId)
      handleGetSchema(projectId)
    }

    // setSchema(mockSchema)
  }, [location.search])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getBankAccount(projectVersionId)

      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnsave = (saveStatus) => {
    console.log('handleOnsave => ', saveStatus)

    saveStatus && handleGetSchema(projectId)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.venderForms && !schema?.forms?.venderForms?.disabled && (
          <BindRmsAccountWidget
            // showCommandButton={true}
            schema={schema.forms.venderForms}
            isSave={handleOnsave}
          />
        )}

        {schema?.forms && (
          <CenterAddBankAccountWidget
            showCommandButton={schema.forms.disabled}
            schema={schema.forms}
            isSave={handleOnsave}
          />
        )}

        <StampedDocumentWidget />
      </SidebarProposal>
    </>
  )

  const mockSchema = {
    header: 'ขั้นที่ 3 บัญชีเงินฝากธนาคารสำหรับเบิกจ่าย (mock เจ้าหน้าที่ศูนย์สัญญา)',
    subHeader: '',
    forms: {
      header: 'บัญชีเงินฝากธนาคารสำหรับเบิกจ่าย',
      buttonText: 'บันทึกบัญชีเงินฝากธนาคารสำหรับเบิกจ่าย',
      disabled: false,
      bankName: {
        optionSelected: null,
        options: [
          {
            id: '000',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'SAMPO BANK',
            value: '000',
          },
          {
            id: '002',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารกรุงเทพ จำกัด (มหาชน)',
            value: 'BBL',
          },
          {
            id: '004',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารกสิกรไทย จำกัด (มหาชน)',
            value: 'TFB',
          },
          {
            id: '005',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารเอบีเอ็น แอมโร เอ็น. วี.',
            value: 'ABN',
          },
          {
            id: '006',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารกรุงไทย จำกัด (มหาชน)',
            value: 'KTB',
          },
          {
            id: '007',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารแห่งประเทศไทย',
            value: 'BOT',
          },
          {
            id: '008',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย',
            value: 'EXIM',
          },
          {
            id: '009',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารมหานคร จำกัด (เลิกกิจการ)',
            value: 'FBC',
          },
          {
            id: '010',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'บรรษัทเงินทุนหลักทรัพย์ห่งประเทศไทย (ควบกิจการ)',
            value: 'IFC',
          },
          {
            id: '012',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารดีบีเอส ไทยทนุ จำกัด (ควบกิจการ)',
            value: 'TDB',
          },
          {
            id: '013',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารแหลมทอง (เลิกกิจการ)',
            value: 'LTB',
          },
          {
            id: '014',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)',
            value: 'SCB',
          },
          {
            id: '015',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารนครหลวงไทย จำกัด (ควบกิจการ)',
            value: 'SCI',
          },
          {
            id: '017',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารซิตี้แบงก์',
            value: 'CITI',
          },
          {
            id: '020',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)',
            value: 'SCBT',
          },
          {
            id: '021',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารศรีนคร จำกัด (เลิกกิจการ)',
            value: 'BMB',
          },
          {
            id: '022',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)',
            value: 'CIMB',
          },
          {
            id: '024',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารยูไนเต็ด โอเวอร์ซีส์ (ไทย) จำกัด (มหาชน)',
            value: 'UOBT',
          },
          {
            id: '025',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)',
            value: 'BAY',
          },
          {
            id: '030',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารออมสิน',
            value: 'GSB',
          },
          {
            id: '031',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารฮ่องกงและเซี่ยงไฮ้ จำกัด',
            value: 'HSBC',
          },
          {
            id: '033',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารอาคารสงเคราะห์',
            value: 'GHB',
          },
          {
            id: '034',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
            value: 'BAC',
          },
          {
            id: '035',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารเกียรตินาคิน จำกัด (มหาชน)',
            value: 'KK',
          },
          {
            id: '036',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารทิสโก้ จำกัด (มหาชน)',
            value: 'TISCO',
          },
          {
            id: '065',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารธนชาต จำกัด (มหาชน)',
            value: 'TBANK',
          },
          {
            id: '066',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารอิสลามแห่งประเทศไทย',
            value: 'ISOT',
          },
          {
            id: '071',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)',
            value: 'TCRB',
          },
          {
            id: '073',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)',
            value: 'LH',
          },
          {
            id: '998',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'เงินสด',
            value: 'CASH',
          },
          {
            id: '999',
            name: 'BANK',
            optional: false,
            disabled: false,
            label: 'ไม่ระบุ',
            value: 'NA',
          },
        ],
        valueLabel: null,
        name: 'bankName',
        label: 'ชื่อธนาคาร',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกชื่อธนาคาร',
          },
        ],
      },
      bankBranch: {
        name: 'bankBranch',
        label: 'สาขา',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกสาขา',
          },
        ],
      },
      bankAccountNumber: {
        name: 'bankAccountNumber',
        label: 'เลขที่บัญชี',
        value: null,
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกเลขที่บัญชี',
          },
        ],
      },
      bankAccountName: {
        name: 'bankAccountName',
        label: 'ชื่อบัญชี',
        value: 'สำหรับนำเสนอ สำนัก 1',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอกชื่อบัญชี',
          },
        ],
      },
      venderForms: {
        header: 'ข้อมูลเวนเดอร์',
        venderRmsInfo: {
          venderCodeLabel: 'รหัส',
          venderCode: 'xxx-000-111-001',
          venderTypeLabel: 'ประเภท',
          venderType: 'บุคคล',
          venderNameLabel: 'ชื่อ-สกุล',
          venderName: 'นายพรพิพัฒน์ กันทะรัญ',
          venderStatusLabel: 'สถานะ',
          venderStatus: 'รออนุมัติ',
        },
        button: {
          refresh: 'ตรวจสอบข้อมูล',
          create: 'สร้าข้อมูลเวนเดอร์',
          bind: 'ผูกบัญชีกับเวนเดอร์',
        },
      },
    },
  }
}
